<template>
  <!-- team profile -->

  <div class="card">
    <!-- <v-sheet v-if="defaultSport == '3'" elevation="0">
      <p class="text-center">Depth chart will coming Soon !</p>
    </v-sheet> -->
    <nba-depth-chart :depthChart="depth" v-if="defaultSport == '1'" />

    <nhl-depthchart :depthChart="depth" v-if="defaultSport == '3'" />

    <nfl-depthchart :depthChart="depth" v-else-if="defaultSport == '4'" />

    <!-- mlb depth chart -->
    <v-row v-else justify="center" align="center">
      <v-col cols="12" md="12" sm="12" v-if="defaultSport == '2'">
        <!-- //* MLB... -->
        <v-row justify="center" align="center">
          <v-col cols="12" md="5" sm="6" class="mx-auto mx-md-0 mx-sm-0">
            <v-chip-group
              v-model="selectionMlb"
              active-class="green accent-3 text--accent-4"
              center-active
              mandatory
            >
              <v-chip
                v-for="selectionMlb in positionMlb"
                :key="selectionMlb"
                :value="selectionMlb"
                @change="getFilterByPosition(selectionMlb)"
              >
                {{ selectionMlb }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>

        <v-sheet elevation="0" class="px-5 py-2 text-center" rounded>
          <!--//*team depth data table -->
          <div class="mt-2">
            <v-data-table
              :headers="depthHeaders"
              :items="getFilterBygames"
              class="elevation-1"
              sort-desc
              sort-by="DraftKingsProjection"
              mobile-breakpoint="0"
              hide-default-footer
            >
              <!-- s.no -->
              <template v-slot:item._id="{ index }">
                <p class="body-2">{{ index + 1 }}</p>
              </template>
              <!-- s.no -->

              <!-- Depth position -->
              <template v-slot:item.Position="{ item }">
                <p class="body-2" v-if="defaultSport == '1'">
                  {{ item.DraftKingsPosition }} ({{ item.DepthChartOrder }})
                </p>
                <p class="body-2" v-if="defaultSport == '2'">
                  {{ item.Position }} ({{ item.DepthOrder }})
                </p>
                <p class="body-2" v-if="defaultSport == '3'">
                  {{ item.DraftKingsPosition }} ({{ item.Started }})
                </p>
                <p class="body-2" v-if="defaultSport == '4'">
                  {{ item.DraftKingsPosition }} ({{ item.Started }})
                </p>
              </template>
              <!-- Depth position -->

              <!-- player name -->
              <template v-slot:item.Name="{ item }">
                <router-link
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: 2 },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  {{ item.Name }}
                </router-link>
              </template>
              <!-- player name ends -->
            </v-data-table>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <!-- mlb depth chart -->
  </div>
</template>

<script>
import _ from "lodash";
import nbaDepthChart from "./depthChartTables/depthChartNba.vue";
import nflDepthchart from "./depthChartTables/depthChartNfl.vue";
import nhlDepthchart from "./depthChartTables/depthChartNhl.vue";

export default {
  name: "depthchart",
  components: {
    nflDepthchart,
    nhlDepthchart,
    nbaDepthChart,
  },
  props: {
    depth: {
      type: [Array, Object],
      default: () => [],
    },
    defaultSport: {
      type: String,
      default: () => "",
    },
  },

  data: () => ({
    depthHeaders: [
      {
        text: "Depth",
        value: "Position",
        sortable: false,
      },
      { text: "Player", value: "Name" },
    ],
    positionMlb: ["C", "1B", "2B", "3B", "SS", "F", "SP", "RP"],
    selectionMlb: "C",
    positionNba: ["PG", "SG", "SF", "PF", "C", "G", "F"],
    selectionNba: "PG",
    positionNhl: ["C", "W", "D", "G"],
    selectionNhl: "C",
    positionNfl: ["QB", "RB", "WR", "TE"],
    selectionNfl: "QB",
    order: [0, 1, 2, 3, 4],
    sortByDepth: [],
    gameOperator: localStorage.getItem("gameOperator"),
  }),

  methods: {
    getFilterByPosition(position) {
      let filterArray = [];
      if (this.defaultSport == "2") {
        filterArray = this.sortByDepth.filter((player) => {
          if (position.includes("C")) {
            return player.Position === "C";
          } else {
            return player.Position.includes(position);
          }
        });
      } else {
        filterArray = this.sortByDepth.filter((player) => {
          return player.DepthChartPosition === position;
        });
      }
      return filterArray;
    },

    getSortedDepthChartData(position) {
      if (this.defaultSport == "1") {
        this.sortByDepth = _.sortBy(this.depth, "DepthChartOrder");
        return this.getFilterByPosition(position);
      } else if (this.defaultSport == "2") {
        this.sortByDepth = _.sortBy(this.depth.DepthCharts, "DepthOrder");
        return this.getFilterByPosition(position);
      } else if (this.defaultSport == "3") {
        this.sortByDepth = _.sortBy(this.depth, "DepthChartOrder");
        return this.getFilterByPosition(position);
      } else if (this.defaultSport == "4") {
        this.sortByDepth = _.sortBy(this.depth, "DepthChartOrder");
        return this.getFilterByPosition(position);
      }
    },
  },

  computed: {
    getFilterBygames() {
      //  -> sorting for depthChart table mlb...
      if (this.defaultSport == "1") {
        return this.getSortedDepthChartData(this.selectionNba);
      } else if (this.defaultSport == "2") {
        return this.getSortedDepthChartData(this.selectionMlb);
      } else if (this.defaultSport == "3") {
        return this.getSortedDepthChartData(this.selectionNhl);
      } else if (this.defaultSport == "4") {
        return this.getSortedDepthChartData(this.selectionNfl);
      }
    },
  },
};
</script>

<style scoped></style>
